import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ProgramsPage from './pages/ProgramsPage'
import GalleryPage from './pages/GalleryPage'
import EnrollmentPage from './pages/EnrollmentPage'
import ContactPage from './pages/ContactPage'

/** Scroll to top on route changes; respect hash anchors */
function ScrollController() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
        return
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname, hash])

  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollController />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/"           element={<HomePage />} />
            <Route path="/about"      element={<AboutPage />} />
            <Route path="/programs"   element={<ProgramsPage />} />
            <Route path="/gallery"    element={<GalleryPage />} />
            <Route path="/enrollment" element={<EnrollmentPage />} />
            <Route path="/contact"    element={<ContactPage />} />
            {/* 404 fallback */}
            <Route
              path="*"
              element={
                <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
                  <p className="text-8xl mb-4" aria-hidden="true">🌱</p>
                  <h1 className="text-3xl font-display font-bold text-brand-navy mb-2">Page Not Found</h1>
                  <p className="text-slate-500 mb-6">The page you're looking for doesn't exist.</p>
                  <a href="/" className="btn-primary">Go Home</a>
                </div>
              }
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  )
}
